"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var clientCoupon_1 = require("../../model/clientCoupon");
var service_1 = require("../../../library/base/service");
var HistoryList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(HistoryList, _super);
    function HistoryList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '历史优惠券列表';
        _this.code = '300410';
        _this.desc = '历史优惠券列表';
        _this.requestParams = new clientCoupon_1.HistoryListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return HistoryList;
}(service_1.BaseService));
exports.HistoryList = HistoryList;
//# sourceMappingURL=historyList.js.map